module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Vue@2.x 主要变更")]), _vm._v(" "), _c('p', [_vm._v("参考"), _c('a', {
    attrs: {
      "href": "https://cn.vuejs.org/v2/guide/migration.html"
    }
  }, [_vm._v("Vue官方文档")]), _vm._v("进行迁移, 这也是Vux组件的代码更新部分，主要包括：")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v(":value.sync")]), _vm._v(" 已经废弃")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("broadcast")]), _vm._v(" 方法已经废弃")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("@click")]), _vm._v(" 需要更改为 "), _c('code', [_vm._v("@click.native")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("v-for")]), _vm._v("的"), _c('code', [_vm._v("(index, item)")]), _vm._v(" => "), _c('code', [_vm._v("(item, index)")])])]), _vm._v(" "), _c('h3', [_vm._v("vue-router 更新")]), _vm._v(" "), _c('p', [_vm._v("配合vue2, "), _c('code', [_vm._v("vue-router")]), _vm._v("同样需要更新到2.0版本以上")]), _vm._v(" "), _c('p', [_vm._v("原来的路由配置修改为：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" routes = [{\n\t"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("path")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'/vux/2.0'")]), _vm._v(",\n\t"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("component")]), _vm._v(": Vux2Demo\n}]\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" router = "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("new")]), _vm._v(" VueRouter({\n  routes\n})\n\n")])]), _vm._v(" "), _c('p', [_vm._v("原来的路由挂载修改为：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("new")]), _vm._v(" Vue({\n  router,\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("render")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("h")]), _vm._v(" =>")]), _vm._v(" h(App)\n}).$mount("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'#app'")]), _vm._v(")\n")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("go")]), _vm._v(" 已经不是过去的 "), _c('code', [_vm._v("go")]), _vm._v("了，要用"), _c('code', [_vm._v("push")]), _vm._v("方法来跳转")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$router.go("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'/somewhere'")]), _vm._v(")\n")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("v-link")]), _vm._v("也废弃了，使用"), _c('code', [_vm._v("router-link")]), _vm._v("组件来代替")]), _vm._v(" "), _c('p', [_vm._v("其他请参考官方升级文档: "), _c('a', {
    attrs: {
      "href": "https://cn.vuejs.org/v2/guide/migration-vue-router.html"
    }
  }, [_vm._v("https://cn.vuejs.org/v2/guide/migration-vue-router.html")])]), _vm._v(" "), _c('h3', [_vm._v("不再生成"), _c('code', [_vm._v("umd")]), _vm._v("文件")]), _vm._v(" "), _c('p', [_vm._v("但是你可以使用"), _c('code', [_vm._v("npm run build-components")]), _vm._v("来生成，请参考文档首页。")]), _vm._v(" "), _c('h3', [_vm._v("双向绑定修改为 "), _c('code', [_vm._v("v-model")])]), _vm._v(" "), _c('p', [_vm._v("所有相关Vux调用的 "), _c('code', [_vm._v(":value.sync")]), _vm._v("都需要更改成 "), _c('code', [_vm._v("v-model")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 0.x")]), _vm._v("\n<component :value.sync="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"someValue\"")]), _vm._v(">"), _c('span', {
    staticClass: "xml"
  }, [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("component")]), _vm._v(">")])]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 2.x")]), _vm._v("\n<component v-model="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"someValue\"")]), _vm._v(">"), _c('span', {
    staticClass: "xml"
  }, [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("component")]), _vm._v(">")])]), _vm._v("\n")])]), _vm._v(" "), _c('h3', [_vm._v("使用 vux-loader")]), _vm._v(" "), _c('p', [_vm._v("原来你可能在webpack中做了这样的配置以正确编译vux的js源码：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("test")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/vux.src.*?js$/")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loader")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'babel'")]), _vm._v("\n}\n")])]), _vm._v(" "), _c('p', [_vm._v("或者你也可能使用了低版本"), _c('code', [_vm._v("vux-loader")]), _vm._v("的"), _c('code', [_vm._v("getBabelLoader")]), _vm._v("方法。")]), _vm._v(" "), _c('p', [_vm._v("现在你可以直接删除这一句了，直接使用vux-loader。")]), _vm._v(" "), _c('p', [_vm._v("在"), _c('code', [_vm._v("webpack.base.conf.js")]), _vm._v("中这样配置：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" vuxLoader = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-loader'")]), _vm._v(")\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("module")]), _vm._v(".exports = vuxLoader.merge(webpackConfig, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("options")]), _vm._v(": {},\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("plugins")]), _vm._v(": [\n    {\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-ui'")]), _vm._v("\n    }\n\t]\n})\n")])]), _vm._v(" "), _c('h3', [_vm._v("引入方式变更")]), _vm._v(" "), _c('p', [_vm._v("原来你可能是单个组件引入，现在在"), _c('code', [_vm._v("vux-loader")]), _vm._v("的支持下你可以直接这样写：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Group, Cell } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('h3', [_vm._v("组件名字变更")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("\n  为什么不参照其他组件库全部加上`X`前缀，主要是因为觉得总要写个`X`相当不顺手。\n")]), _vm._v(" "), _c('p', [_vm._v("因Vue2.0限制组件名不能与原有的html5标签一样，因此部分组件进行了重命名，加上 "), _c('code', [_vm._v("x-")]), _vm._v("前缀，所有需要加前缀的组件如下：")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("Progress")]), _vm._v(" => "), _c('code', [_vm._v("XProgress")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("Switch")]), _vm._v(" => "), _c('code', [_vm._v("XSwitch")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("Dialog")]), _vm._v(" => "), _c('code', [_vm._v("XDialog")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("Address")]), _vm._v(" => "), _c('code', [_vm._v("XAddress")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("Circle")]), _vm._v(" => "), _c('code', [_vm._v("XCircle")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("XButton")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("XImg")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("XInput")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("XTextarea")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("XHeader")])])]), _vm._v(" "), _c('h3', [_vm._v("各个组件变更：")]), _vm._v(" "), _c('h4', [_vm._v("Swiper 引入路径变化")]), _vm._v(" "), _c('p', [_vm._v("目录结构变化，与其他有子组件的统一，导致引入方式变化：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 0.x")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" Swiper "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux/src/components/swiper'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" SwiperItem "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux/src/components/swiper-item'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 2.0")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" Swiper "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux/src/components/swiper/swiper'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" SwiperItem "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux/src/components/swiper/swiper-item'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 或者")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Swiper, SwiperItem } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux/src/components/swiper'")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// with vux-loader")]), _vm._v("\n")])]), _vm._v(" "), _c('h4', [_vm._v("ColorPicker 废弃")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("\n  `2.0.0`可用用，但是后面不再维护。\n")]), _vm._v(" "), _c('p', [_vm._v("这个组件可以由"), _c('code', [_vm._v("cell")]), _vm._v("配合"), _c('code', [_vm._v("slot")]), _vm._v("扩展出来，而且更灵活。没有做过统计，但是感觉使用人数应该挺少。")]), _vm._v(" "), _c('h4', [_vm._v("Countdown 废弃")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("\n  `2.0.0`可用，但是后面不再维护。\n")]), _vm._v(" "), _c('p', [_vm._v("功能薄弱，比较鸡肋。")]), _vm._v(" "), _c('h4', [_vm._v("Scroller reset方法更新")]), _vm._v(" "), _c('p', [_vm._v("由于 Vue@2.x 的"), _c('code', [_vm._v("broadcast")]), _vm._v("方法已经废弃，并且之前的设计也并不是很好，uuid的绑定也其实是没必要的。")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("reset方法变成使用ref的"), _c('code', [_vm._v("reset()")]), _vm._v("方法")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("pullup reset 变成 ref 的 "), _c('code', [_vm._v("donePullup()")]), _vm._v("方法")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("pullup disable 变成 ref 的 "), _c('code', [_vm._v("disablePullup()")]), _vm._v("方法")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("pullup enable 变成 ref 的 "), _c('code', [_vm._v("enablePullup()")]), _vm._v("方法")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("pulldown reset 变成 ref 的 "), _c('code', [_vm._v("donePulldown()")]), _vm._v("方法")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("pullup和pulldown的status绑定变成"), _c('code', [_vm._v("v-model=\"status\"")]), _vm._v("绑定，示例")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("status: {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("pullupStatus")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'default'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("pulldownStatus")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'default'")]), _vm._v("\n}\n")])])])]), _vm._v(" "), _c('p', [_vm._v("详细参照"), _c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/components?id=scroller"
    }
  }, [_vm._v("Scroller文档")]), _vm._v("进行更新")]), _vm._v(" "), _c('h4', [_vm._v("表单默认required为true")]), _vm._v(" "), _c('p', [_vm._v("保持和"), _c('code', [_vm._v("html")]), _vm._v("规范一致, 影响的组件有 "), _c('code', [_vm._v("XInput")]), _vm._v(" "), _c('code', [_vm._v("Checklist")])]), _vm._v(" "), _c('h4', [_vm._v("Checklist 不显示错误提示")]), _vm._v(" "), _c('p', [_vm._v("考虑到错误样式目前并不优雅，而用户有自定义错误样式的需要，因此处理成emit一个错误事件+底部slot， 用户可自行处理。")]), _vm._v(" "), _c('h4', [_vm._v("XInput 的valid获取")]), _vm._v(" "), _c('p', [_vm._v("由于Vue2的$ref不再是响应的，因此不能直接在模板中通过ref调用组件的valid值(会报undefined)，所以需要变成在提交时再进行ref来获取valid值。")]), _vm._v(" "), _c('h4', [_vm._v("XAddress 默认地址数据更新")]), _vm._v(" "), _c('p', [_vm._v("目前引用方式：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XAddress, ChinaAddressData } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("如果你想继续使用旧版本数据")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XAddress, ChinaAddressV1Data } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("按照"), _c('a', {
    attrs: {
      "href": "http://www.stats.gov.cn/tjsj/tjbz/xzqhdm/201608/t20160809_1386477.html"
    }
  }, [_vm._v("最新统计局数据")]), _vm._v("进行更新，部分区域已经不存在，部分id做了更新。因此请"), _c('em', [_vm._v("谨慎")]), _vm._v("更新，评估后端数据存储设计和前端交互再进行更新，避免错误更新用户数据或者导致数据丢失。")]), _vm._v(" "), _c('p', [_vm._v("完整更新如下图:")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://github.com/airyland/china-area-data/raw/master/v2.0.0.changes.png",
      "alt": ""
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-40be2a3c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-40be2a3c"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/upgrade-to-2-6.vue
// module id = 2178
// module chunks = 388